import React from 'react';

const Separador = () => {
    return (
        <div className="flex items-center w-full my-4 text-[#445063] 
        font-semibold text-sm">
            <div className="flex-grow border-t border-gray-300"></div>
            <span className="px-4">Ó</span>
            <div className="flex-grow border-t border-gray-300"></div>
        </div>
    )
}
export default Separador;